const LABEL_LEGEND_MATCH_TYPE = {
  ML_MATCH: 'ML',
  FUZZY_MATCH: 'FUZZY',
}

export default LABEL_LEGEND_MATCH_TYPE
